import React, { useEffect, useRef, useState } from "react";
import "./Youtube.css";
import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip'

function Youtube() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

    const togglePopup = () => {
      setIsPopupOpen(!isPopupOpen);
    };

  const videoEl = useRef(null);

  const attemptPlay = () => {
    videoEl &&
      videoEl.current &&
      videoEl.current.play().catch(error => {
        console.error("Error attempting to play", error);
      });
  };

  useEffect(() => {
    attemptPlay();
  }, [isPopupOpen]);

  return (
    <div className="video-app" style={{ alignItems: "center" }} id="videoone">
      <h1 className="videotitle" >Reunion Class Gifts</h1>
      <p className="lasting-impact">Coming together for a shared purpose and a lasting impact</p>
      {/* Video player home */}
      <div style={{marginBottom: "30px"}}>
        <video
          className="videosec"
          loop
          autoPlay
          muted          
          alt="All the devices"
          src="./assets/sequence1.mp4"
          ref={videoEl}
        />
      </div>
      <button data-tooltip-id="my-tooltip" data-tooltip-content="~ 4 mins" className="share-memory-btn1" style={{margin: "15px 0 50px"}} onClick={togglePopup}>
        Watch Full Video        
      </button>
      <Tooltip id="my-tooltip" style={{color: "#fff"}} />
      {isPopupOpen && (
        <div className="popup">
          <div className="popup-inner popup-container">
            <button className="close-btn1" onClick={togglePopup}>
              X
            </button>            
              <video
                className="videosec inner-video"                
                loop
                autoPlay
                muted
                controls
                alt="All the devices"
                src="./assets/sequence.mp4"
                ref={videoEl}
              />            
          </div>
        </div>
      )}

    </div>
  );
}
export default Youtube;